<template>
    <VirtualsResults :gameName="'drone'"></VirtualsResults>
</template>

<script>
import VirtualsResults from './Components/VirtualsResults';
export default {
    name: 'roulette',
    components: {
        VirtualsResults,
    },
};
</script>
